<template>
  <div id="AddCollegeDialog" class="wrap">
    <div class="maxContainer">
      <div class="offset-md-3 col-md-6 offset-sm-2 col-sm-8 hidden-sm-and-down">
        <div @click="backDesktop" class="headerFake__back">
          <a class="headerFake__backLink">
            <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
            <span class="headerFake__backText">Back</span>
          </a>
        </div>
      </div>
      <!-- Mobile App Bar -->
       <v-app-bar  class="grey lighten-3 d-md-none"  fixed  elevate-on-scroll  >
        <v-layout justify-center align-center>
          <span class="title blue--text text--darken-3 ml-1"> Add College</span>
        </v-layout>
      </v-app-bar>
      <v-card class=" mb-5 pt-5 d-md-none" flat v-if="$resize && $mq.below(960)" >
  
  
         <v-card-text class="mt-0 pt-0 px-0 ">
          <v-container  grid-list-md pt-0 >
            <!-- College Info -->
            <v-form>
              <!-- College Name -->
              <v-text-field  outlined v-model="college_name" label="College Name" required clearable></v-text-field>
                <!-- State Date -->
                 <v-flex xs12>
                    <v-menu ref="menu2"
                            :close-on-content-click="false"
                            v-model="menu2"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            full-width
                            minWidth="290">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            slot="activator"
                            v-model="computedCollegeStartDateFormattedMomentjs"
                            label="Start Date"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            clearable
                            outlined
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="college_start_date" no-title @input="menu2 = false"></v-date-picker>
                    </v-menu>
                  </v-flex>
  
                <v-flex xs12>
                    <v-select
                      v-model="college_type"
                      :items="['2 Year', '4 Year']"
                      label="College Type"
                      required
                      outlined
                      clearable
                    ></v-select>
                  </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="college_term_system"
                    :items="['Semester', 'Quarter', 'Trimester']"
                    label="College Term System"
                    required
                    clearable
                    outlined
  
                    hide-details
                  ></v-select>
                </v-flex>
  
  
                <v-flex  xs12 sm6 md4 ml-2 class="mt-4">
                  <span class="title font-weight-regular mb-1 ">Degree:</span>
                  <v-radio-group v-model="degree" row class="mt-1 mb-0 pb-0">
  
  
                    <v-radio
                      label="In Progress"
                      value="In Progress"
                      color="green"
                    ></v-radio>
                    <v-radio
                      label="Completed"
                      value="Completed"
                      color="green"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
  
  
                <v-flex  class="mt-0 pt-0" xs12 sm6 md4 v-if="degree === 'Completed'">
                  <v-menu
                    class="mt-0 pt-0"
                    ref="menu3"
                    :close-on-content-click="false"
                    v-model="menu3"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        class="mt-0 pt-0"
                        slot="activator"
                        v-model="computedCollegeGraduationDateFormattedMomentjs"
                        label="Graduation Date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        hide-details
                        outlined
                        clearable
                        v-on="on"
                      ></v-text-field>
                      </template>
                    <v-date-picker v-model="college_graduation_date" no-title @input="menu3 = false"></v-date-picker>
                  </v-menu>
                </v-flex>
  
  
                <v-flex xs12  class="mt-0 pt-0" v-if="degree === 'Completed'">
                  <v-select
                  class="mt-4 pt-1 pb-1"
                    v-model="college_degree_awarded"
                    :items="['Associate', 'Bachelor', 'Masters','Doctorate', 'Post Baccalaureate ']"
                    label="Degree Awarded"
                    required
                    outlined
                    clearable
                  ></v-select>
                </v-flex>
            </v-form>
  
            <v-layout row class="mt-2 " style="marginBottom:50px;" >
              <!-- Add College Button -->
              <v-btn
                color="green"
                @click="addCollege"
                block
                large
                depressed
                :disabled="checkAddCollege"
              >
  
                <span class="white--text"> Add College</span>
              </v-btn>
            </v-layout>
          </v-container>
         </v-card-text>
      </v-card>
  
       <!-- Back Button -->
      <v-btn  class="mr-4 ml-2  fixed elevation-0 d-md-none" color="red"  fab  small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>
  
        <v-card class=" elevation-0 hidden-sm-and-down" v-if="$resize && $mq.above(960)">
          <v-layout justify-center align-center>
           <span class="title blue--text text--darken-3 ml-1"> Add College</span>
          </v-layout>
          <v-card-text class="mt-0 pt-0 px-0 ">
  
            <!-- College Info -->
            <v-container>
              <div class="HealthcareHours__cover offset-md-3 col-md-6 offset-sm-2 col-sm-8 ">
                <v-form >
                  <!-- College Name -->
                  <v-flex xs12>
                    <v-text-field  outlined v-model="college_name" label="College Name" required clearable></v-text-field>
                  </v-flex>
                  <!-- Start Date -->

                  <v-flex xs12>
                    <v-menu ref="menu2"
                            :close-on-content-click="false"
                            v-model="menu2"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            minWidth="290">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            slot="activator"
                            v-model="computedCollegeStartDateFormattedMomentjs"
                            label="Start Date"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            clearable
                            outlined
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker width="290" v-model="college_start_date" no-title @input="menu2 = false"></v-date-picker>
                    </v-menu>
                  </v-flex>
  
                   <!-- College Type -->
                  <v-flex xs12 class="pb-7">
                    <v-select
                      v-model="college_type"
                      :items="['2 Year', '4 Year']"
                      label="College Type"
                      required
                      outlined
                      hide-details
                      clearable
                    ></v-select>
                  </v-flex>
  
  
                  <!-- College Term  -->
  
                <v-flex xs12 class="pb-7">
                  <v-select
                    v-model="college_term_system"
                    :items="['Semester', 'Quarter', 'Trimester']"
                    label="College Term System"
                    required
                    clearable
                    outlined
                    hide-details
                  ></v-select>
                </v-flex>
  
  
                <v-flex xs12>
                  <span class="title font-weight-regular mb-1 ">Degree:</span>
                    <v-radio-group v-model="degree" row class="mt-1 mb-0 pb-0">
                      <v-radio
                            label="In Progress"
                            value="In Progress"
                            color="green"
                          ></v-radio>
                      <v-radio
                            label="Completed"
                            value="Completed"
                            color="green"
                          ></v-radio>
                  </v-radio-group>
                </v-flex>
  
  
                  <div v-if="degree === 'Completed'">
                    <v-flex xs12>
                      <v-menu
                        class="mt-0 pt-0"
                        ref="menu3"
                        :close-on-content-click="false"
                        v-model="menu3"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                        >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            class="mt-0 pt-0"
                            slot="activator"
                            v-model="computedCollegeGraduationDateFormattedMomentjs"
                            label="Graduation Date"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            hide-details
                            outlined
                            clearable
                            v-on="on"
                          ></v-text-field>
                          </template>
                        <v-date-picker v-model="college_graduation_date" no-title @input="menu3 = false"></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 class="pt-8">
                      <v-select
                        v-model="college_degree_awarded"
                        :items="['Associate', 'Bachelor', 'Masters','Doctorate', 'Post Baccalaureate ']"
                        label="Degree Awarded"
                        required
                        outlined
                        clearable
                      ></v-select>
                    </v-flex>
                  </div>
  
  
                  <v-layout class="mt-2 " justify-center style="marginBottom:50px;" >
                    <!-- Add College Button -->
                    <v-btn
                      color="green"
                      @click="addCollege"
                      style="width:100%"
                      large
                      depressed
                      :disabled="checkAddCollege"
                    >
                      <span class="white--text"> Add College</span>
                    </v-btn>
                  </v-layout>
  
                </v-form>
              </div>
            </v-container>
  
  
  
         </v-card-text>
  
        </v-card>
    </div>




  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    props: [],
    data() {
      return {
         e1: 0,
        modal: false,
        alert: false,
        menu2: false,
        menu3: false,
        AddCollegeDialog : false,
        college_name: '',
        degree: 'In Progress',
        college_start_date: '',
        college_type: '',
        college_term_system: '',
        college_degree_awarded: '',
        college_graduation_date: '',


        semesterForm : false,
        courseForm : false,

        semester_completion_status: '',
        semester_academic_status: '',
        semester_term: '',
        semester_year: '',
        course_id : '',
        course_semester: '',
        course_lab: true,
        course_credits: '',
        course_grade: '',
      }
    },
    methods: {
       formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },
      back() {
        this.$router.push('/dashboard/mygrades');
      },
      backDesktop () {
        this.$router.push('/dashboard');
      },
      showAddCollege(user) {
        if(user !== null && user !== undefined ){
          this.AddCollegeDialog = true
        }
        else {
          this.alert = true
        }
      },
      next () {
        if(this.semesterForm === false ) {

          this.collegeForm = false
           this.semesterForm = true
        } else if(this.semesterForm = true){
          this.courseForm = true
          this.semesterForm = false
        }

      },
      addCollege () {
        const collegeData = {
          college_name : this.college_name,
          degree : this.degree,
          college_start_date: this.college_start_date,
          college_type: this.college_type,
          college_term_system: this.college_term_system,
          college_degree_awarded: this.college_degree_awarded,
          college_graduation_date: this.college_graduation_date,

        }
        this.dialog = false
        this.$store.dispatch('setUserCollege', collegeData)
        this.$router.go('-1')
        // if( screen.width >= 960) {
        //   this.$router.push('/dashboard')
        // } else {
        //   this.$router.push('/dashboard/mygrades')
        // }
      }
    },
    computed : {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
      checkAddCollege() {
        
        if(
          (this.college_name === '' || this.college_name === null) || 
          this.college_start_date === '' ||  
          (this.college_type === ''|| this.college_type === undefined) || 
          (this.college_term_system === '' || this.college_term_system === undefined)
          // && this.degree === 'In Progress'
          || ( this.degree === "Completed" && ( (this.college_degree_awarded === '' || this.college_degree_awarded === undefined) || this.college_graduation_date === '' ) )
          ){
          return true
        } else {
          return false
        }
      },
      checkAddCourse () {
        if(this.semester_completion_status === '' || this.semester_academic_status === '' || this.semester_term === '' && this.semester_year === '') {
          return true
        } else {
          return false
        }

      },
      user () {
        return this.$store.getters.user
      },
        userColleges () {
        return this.$store.getters.userColleges
      },
          courses() {
        return this.$store.getters.loadedCourses
      },
      computedCollegeStartDateFormattedMomentjs() {
         return this.college_start_date ? moment(this.college_start_date).format('MM/DD/YYYY') : ''
      },
      computedCollegeGraduationDateFormattedMomentjs() {
        return this.college_graduation_date ? moment(this.college_graduation_date).format('MM/DD/YYYY') : ''
      }
    },
    watch : {
      degree() {
        if(this.degree === 'In Progress') {
          this.college_degree_awarded = '',
          this.college_graduation_date = ''
        }
      }
    }
  }
</script>

<style scoped>

.card {
  border-radius: 5px;

}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 90%;
  margin: 0px auto;

  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

    .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;

  }
  @media (min-width: 960px) {
    .fixed {
        margin-bottom: 110px;
    }
}

.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}


.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}



  .wrap {
    margin-top: 8vh !important;
    
  }

</style>




// WEBPACK FOOTER //
// src/components/Dashboard/Grades/Colleges/AddCollegeDialog.vue